module.exports = __webpack_public_path__ + "img/home_bg_indonesia.9a9e4f38.jpg";